module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	
	require('jquery-ui/ui/core');
	require('jquery-ui/ui/widget');
	require('jquery-ui/ui/dialog');
	require('jquery-ui/ui/tooltip');

	require('script!jquery.mCustomScrollbar.min');
	require('../../../../model/member/css/jquery.mCustomScrollbar.css');
	require('../../../../../common/frame/widget/controls/select')(fox);
	require('../../../../../common/frame/widget/controls/select/dynamic')(fox);
	require('../../../../../common/frame/options/controls/customSelect')(fox);
	require('../../../../../common/frame/widget/contentPager')(fox);
	require('../../../../../common/frame/widget/promisePreloader')(fox);
	require('../../../../../common/frame/widget/sidebarSlider')(fox);
	require('../../../../model/common/widget/anchorNavigator')(fox);
	require('../../../../../common/frame/widget/passrecovery')(fox);
	require('../../../../../../common-components/intercom')(fox);

	require('fox-dynamic-injection!fox-template-loader!../../../../../common/frame/templates/controls/select.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/frame/templates/preloader.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/frame/templates/contentPager.tpl')(fox);

	require('../../../../../common/faq/widget/faq')(fox);
	require('../../../../../common/faq/widget/sitepage/faq/question')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../common/templates/sitepage/faq.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/question.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/faqs.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/main.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/result.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/searchresult.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../../common/faq/templates/sitepage/faq/tags.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../model/common/templates/promo/termsofuse.tpl')(fox);

	require('../../../../affiliate/global/member/stylus/_style.styl');

	require('../../common/widget/unsubscribe')(fox);
	require('../components/iframe')(fox);
	require('script!clipboard/dist/clipboard');

	require('GDPR')(fox);
	require('GDPR-popups')(fox);
	require('popupWidget')(fox);
	require('common-widgets/PopupCommon')(fox);
	require('../../../../../common/components/GDPR-popups')(fox);
	//require('../../../../model/promo2/components/login-wizard')(fox);
	require('../components/login-wizard')(fox);
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./dependencies/dependencies.js
// module id = 39
// module chunks = 5